'use strict';

exports.__esModule = true;
exports.createFeatureStyles = exports.TYPE = exports.createFeature = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = require('immutable');

var _ordinal = require('ordinal');

var _ordinal2 = _interopRequireDefault(_ordinal);

var _theme = require('../../../styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var HOME_ICON = '//quiqup-web-app.s3.amazonaws.com/images/icons/dropoff_home.png';
var PICKUP_ICON = '//quiqup-web-app.s3.amazonaws.com/images/icons/pickup_pin%402x.png';
var TYPE = {
  QUIQEE: 'QUIQEE',
  WAYPOINT: 'WAYPOINT'
};

var WP_TYPES = {
  pickup: 'pickup',
  dropoff: 'dropoff'
  // TODO: return: 'return',
};

var WP_STATE = {
  delivery_failed: 'delivery_failed',
  pending: 'pending',
  arrived: 'arrived',
  finished: 'finished'
};

var createFeatureStyles = function createFeatureStyles(color, pin) {
  var backgroundColor = color ? { backgroundColor: color } : {};
  var backgroundImage = pin ? { backgroundImage: 'url(' + pin + ')' } : {};

  return {
    header: _extends({}, backgroundColor, backgroundImage),
    line: _extends({}, backgroundColor),
    point: _extends({}, backgroundColor)
  };
};

var createWaypointStyles = function createWaypointStyles(waypoint) {
  var _ref = waypoint.geoJsonProps || {},
      color = _ref.color,
      pin = _ref.pin;

  var isDropoff = waypoint.waypointType === WP_TYPES.dropoff;
  var pickupHasIcon = true;
  var icon = pin;
  var waypointColor = color;

  if (!pin) {
    var categoryIcon = waypoint.category && waypoint.category.icon && waypoint.category.icon.medium.url;

    if (!categoryIcon) {
      categoryIcon = PICKUP_ICON;
      pickupHasIcon = false;
    }

    icon = isDropoff ? HOME_ICON : categoryIcon;
  }

  if (!waypointColor) {
    var getColor = function getColor() {
      if (isDropoff) {
        switch (waypoint.state) {
          case WP_STATE.delivery_failed:
            return _theme2.default.redDark;
          case WP_STATE.arrived:
          case WP_STATE.finished:
            return _theme2.default.greenDark;
          default:
            return _theme2.default.navy;
        }
      }

      if (pickupHasIcon) {
        return _theme2.default.white;
      }

      return _theme2.default.navy;
    };
    waypointColor = getColor();
  }

  return createFeatureStyles(waypointColor, icon);
};

function quiqeeProps(waypoint) {
  var _ref2 = waypoint.geoJsonProps || {},
      color = _ref2.color,
      pin = _ref2.pin;

  return {
    transportMode: waypoint.transportMode,
    name: waypoint.fullname,
    popupHtml: waypoint.fullname,
    styles: createFeatureStyles(color, pin)
  };
}

var getLocation = function getLocation(waypoint) {
  return waypoint.location || waypoint.currentLocation || waypoint.lastLocation || waypoint.currentEndLocation;
};

function waypointProps(waypoint) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      withPositionBadge = _ref3.withPositionBadge;

  var location = getLocation(waypoint);
  var badge = withPositionBadge && +waypoint.position ? (0, _ordinal2.default)(+waypoint.position) : null;
  return {
    name: location.name || location.listName,
    popupHtml: location.address1,
    styles: createWaypointStyles(waypoint),
    badge: badge
  };
}

var toPointFeature = function toPointFeature(coords, properties) {
  return {
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [].concat(_toConsumableArray(coords))
    },
    properties: properties
  };
};

var createFeature = function createFeature(wp, type, options) {
  var waypoint = _immutable.Iterable.isIterable(wp) ? wp.toJS() : wp;
  var location = getLocation(waypoint);

  var _ref4 = waypoint.coords ? waypoint : location,
      coords = _ref4.coords;

  var isQuiqee = type === TYPE.QUIQEE;
  var properties = isQuiqee ? quiqeeProps(waypoint, options) : waypointProps(waypoint, options);
  return toPointFeature(coords, _extends({
    id: waypoint.id,
    type: isQuiqee ? 'courier' : 'waypoint'
  }, properties, waypoint.geoJsonProps));
};

exports.createFeature = createFeature;
exports.TYPE = TYPE;
exports.createFeatureStyles = createFeatureStyles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/components/qu-map/qu-map-abstract/qu-map-abstract.helpers.js
// module id = 369
// module chunks = 0